import React, { useState } from 'react'

import { SanityQuestionAndAnswer, SanityQuestionsAndAnswers } from '../../../graphql/gatsby'
import * as Styled from './styled'

export type QuestionsAndAnswersProps = SanityQuestionsAndAnswers

interface QuestionAndAnswerItemProps {
  item: SanityQuestionAndAnswer
}

const QuestionAndAnswerItem: React.FC<QuestionAndAnswerItemProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Styled.QuestionAndAnswerItem onClick={() => setIsOpen(!isOpen)}>
      <Styled.QuestionContainer>
        <Styled.Question>{item.question}</Styled.Question>
        <Styled.Icon $isOpen={isOpen} />
      </Styled.QuestionContainer>
      {isOpen && (
        <Styled.AnswerContainer>
          <Styled.Answer>{item.answer}</Styled.Answer>
        </Styled.AnswerContainer>
      )}
    </Styled.QuestionAndAnswerItem>
  )
}

const QuestionsAndAnswers: React.FC<QuestionsAndAnswersProps> = ({ title, qaItems }) => {
  return (
    <Styled.Container>
      <div>{title && <Styled.Title>{title}</Styled.Title>}</div>
      <div>
        {qaItems &&
          qaItems.map((item, index) => !!item && <QuestionAndAnswerItem key={index} item={item} />)}
      </div>
    </Styled.Container>
  )
}

export default QuestionsAndAnswers
